import PageLayout, { PageLayoutProps } from '@ms/yammer-web-core-ui/dist/components/PageLayout';
import { ContainerWidthProvider } from '@ms/yammer-web-core-ui/dist/util/responsiveness';
import { useIsVivaEngageApp } from 'hooks/useIsVivaEngageApp';
import React, { FC } from 'react';

import LoadableAppLayout from './LoadableAppLayout';

const PageLayoutSwitcher: FC<PageLayoutProps> = (props) => {
  const isVivaEngageApp = useIsVivaEngageApp();

  return isVivaEngageApp ? (
    <ContainerWidthProvider>
      <LoadableAppLayout {...props} />
    </ContainerWidthProvider>
  ) : (
    <PageLayout {...props} />
  );
};

export default PageLayoutSwitcher;
